import { getHttpClient } from 'src/http-client';

export const dispatchFinishSetupEventService = async (input: {
  organizationName: string;
  projectId: string;
}) => {
	try {
		const apiUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL as string;
		const httpClient = getHttpClient();
		await httpClient.post(`${apiUrl}/application-events/finish-setup/${input.organizationName}/${input.projectId}`);

	} catch (error) {
		console.error(error);
	}
};